export default { title: 'Google-recensie uploaden' };
